import { useNavigate } from "react-router-dom";
import ErrorImage from "../../../assets/img/Error403.png"
import Explore from "../../../assets/icons/ErrorExploreIcon.svg"

const Error403 = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-white p-3">
      <div className="text-center">
        <h5 className="fw-bold mb-4" style={{fontSize:"44px",fontWeight:700}}>Access restricted</h5>
        <p className="mb-2" style={{fontSize:"30px"}}>
You don't have permission to view this page.<br />
Don't worry, you can find your way back.
        </p>
        <div>
        <img
          src={ErrorImage}
          alt="404 Illustration"
          className="img-fluid mb-4"
          style={{ maxWidth: "500px" }}
        />
        </div>
        <button
          className="btn btn-primary py-2 px-3 fs-5"
          onClick={() => navigate("/")}
        >
          Explore <span className="ms-4"><img src={Explore} alt="expand" width={15} height={15}/></span>
        </button>
      </div>
    </div>
  );
};

export default Error403;